import { useState } from 'react'

import { useApolloClient } from '@apollo/client'
import HistoryIcon from '@mui/icons-material/History'
import { Button, Tooltip } from '@mui/material'
import { useFormContext } from 'react-hook-form'

import { SelectTopBookingDialog } from 'components/bookings'
import {
  BookingAddressType,
  GetUserBookingDocument,
  useGetUserTopBookingsQuery,
} from 'generated/graphql'
import { mapToBookingAddressForm } from 'helpers'
import { useRecalculateDistance } from 'hooks/useRecalculateDistance'
import { TBookingForm } from 'types'

export const CustomerHistoryButton = () => {
  const [openSelectTopBookingDialog, setOpenSelectTopBookingDialog] = useState(false)
  const client = useApolloClient()
  const { reset, getValues } = useFormContext<TBookingForm>()
  const { recalculateDistance } = useRecalculateDistance()

  const { data, loading } = useGetUserTopBookingsQuery({
    fetchPolicy: 'network-only',
  })

  const topBookingList = data?.userTopBookings

  const handleSelectTopBooking = async (bookingId: number) => {
    try {
      const { data } = await client.query({
        query: GetUserBookingDocument,
        variables: { bookingId: Number(bookingId) },
        fetchPolicy: 'network-only',
      })

      const booking = data?.userBooking
      if (!booking) return

      const { addresses, tariffId, isWaitAndReturn } = booking

      const collectionAddresses = addresses
        .filter((addr: any) => addr.type === BookingAddressType.Collection)
        .map(mapToBookingAddressForm)

      const deliveryAddresses = addresses
        .filter((addr: any) => addr.type === BookingAddressType.Delivery)
        .map(mapToBookingAddressForm)

      reset({
        ...getValues(),
        collectionAddresses,
        deliveryAddresses,
        tariffId: tariffId != null ? String(tariffId) : '',
        isWaitAndReturn,
      })

      recalculateDistance()

      setOpenSelectTopBookingDialog(false)
    } catch (err) {
      console.error('Failed to fetch booking details:', err)
    }
  }

  const handleSelectTopBookingClick = () => {
    setOpenSelectTopBookingDialog(true)
  }

  return (
    <>
      <Tooltip title='History' arrow>
        <span>
          <Button
            variant='contained'
            color='grey'
            startIcon={<HistoryIcon />}
            disabled={!topBookingList || topBookingList.length === 0}
            onClick={handleSelectTopBookingClick}>
            History
          </Button>
        </span>
      </Tooltip>

      {openSelectTopBookingDialog && (
        <SelectTopBookingDialog
          topBookingList={topBookingList}
          loadingTopBookings={loading}
          open={openSelectTopBookingDialog}
          setOpen={setOpenSelectTopBookingDialog}
          onSelectTopBooking={handleSelectTopBooking}
          title='History'
        />
      )}
    </>
  )
}
